export default {
  primary: {
    main: "#e83d84",
    light: "#ec5f99",
  }
}
